export default "__VITE_ASSET__CHkIR66f__"